"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEqualScope = isEqualScope;
exports.isGreatOrEqual = isGreatOrEqual;
exports.delay = delay;
exports.getObjectPath = getObjectPath;
exports.getContextId = getContextId;
exports.trimAccessToken = trimAccessToken;
exports.normalizeScope = normalizeScope;
exports.printValue = printValue;
exports.recursivePrintObject = recursivePrintObject;
exports.prettyPrintAny = prettyPrintAny;
exports.gp = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function isSuperset(set, subset) {
  var _iterator = _createForOfIteratorHelper(subset),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var elem = _step.value;

      if (!set.has(elem)) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
}

function isEqualScope(left, right) {
  /*
   * Возможно иногда не приходят scope с каких-то клиентов
   * в этом случае надеемся что они выданы
   */
  if (typeof right !== 'string') {
    return true;
  }

  if (typeof left !== 'string') {
    return true;
  }

  return normalizeScope(left) === normalizeScope(right);
}

function isGreatOrEqual(request, receive) {
  /*
   * Возможно иногда не приходят scope с каких-то клиентов
   * в этом случае надеемся что они выданы
   */
  if (typeof request !== 'string') {
    return true;
  }

  if (typeof receive !== 'string') {
    return true;
  }

  var requestSet = new Set(normalizeScope(request).split(','));
  var receiveSet = new Set(normalizeScope(receive).split(','));
  return isSuperset(receiveSet, requestSet);
}

function delay(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}
/**
 * @param {object} object
 * @param {string[]|number[]|string} path
 * @return {Object|string|number|any|null}
 */


function getObjectPath(object, path) {
  return path.split('.').reduce(function (buffer, x) {
    if (buffer && buffer.hasOwnProperty(x)) {
      return buffer[x];
    } else {
      return null;
    }
  }, object);
}

var gp = getObjectPath;
exports.gp = gp;

function getContextId() {
  return "".concat(Date.now().toString(36), ".").concat(Math.ceil(Math.random() * 1000000).toString(36));
}

function trimAccessToken(token) {
  return "".concat(token.substr(0, 5), "...").concat(token.substr(-5));
}

function normalizeScope(scope) {
  if (typeof scope === 'string') {
    return normalizeScope(scope.split(',').map(function (s) {
      return s.trim();
    }));
  } else {
    return scope.concat([]).sort(function (a, b) {
      return a.localeCompare(b);
    }).join(',');
  }
}

function printValue(value) {
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var type = (0, _typeof2["default"])(value);
  var isNull = value === null;

  if (isNull) {
    return '(null) null';
  } else if (type === 'object') {
    return "(Object[".concat(value.constructor.name, "]) ").concat(recursivePrintObject(value, req + 1));
  } else {
    return "(".concat(type, ") ").concat(value.toString());
  }
}

function recursivePrintObject(obj) {
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (req > 3) {
    return 'Object';
  }

  if ((0, _typeof2["default"])(obj) === 'object') {
    var res = '{';

    for (var key in obj) {
      if (!obj.hasOwnProperty(key)) {
        continue;
      }

      var value = obj[key];
      res += "".concat(key, ": ").concat(printValue(value), " \n");
    }

    res += '}';
    return res;
  } else {
    return printValue(obj);
  }
}

function prettyPrintAny(x) {
  try {
    var res = JSON.stringify(x);

    if (res === '{}') {
      var objectPrint = recursivePrintObject(x);

      if (objectPrint.length > res.length) {
        return objectPrint;
      } else {
        return res;
      }
    } else {
      return res;
    }
  } catch (e) {
    var castError = (e === null || e === void 0 ? void 0 : e.message) || 'Unknown cast error';
    var _constructor = x.constructor.name;
    return "Unknown error: castError ".concat(castError, " ").concat(_constructor, " ").concat(prettyPrintAny(x));
  }
}